<template>
  <el-container>
      <el-header style="height:50px;padding-top:10px;">
        <el-page-header @back="goBack">
          <slots name="content">ddd</slots>
        </el-page-header>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
</template>

<script>
export default {
    data() {
      return {
        
      }
    },
    created() {
      
    },
    mounted() {
      
    },
    methods: {
      goBack() {
        this.$router.push({ name: 'home-project', params: { }})
      }
    }
  };
</script>

<style>
/* .el-header {
  height:50px;
  padding-top:10px;
} */
</style>